class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    // Skip cart update if we're programmatically reverting the quantity
    if (event.target.hasAttribute("data-reverting")) {
      return;
    }

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
          console.log("Parsed cart state:", parsedState);

          // Check if the response contains an error
          if (parsedState.errors) {
            console.log("Cart update failed with error:", parsedState.errors);
            throw new Error(parsedState.errors);
          }

          // Success case - update the cart
          this.classList.toggle("is-empty", parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");

          if (cartFooter)
            cartFooter.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );
          if (cartDrawerWrapper) {
            cartDrawerWrapper.classList.toggle(
              "is-empty",
              parsedState.item_count === 0
            );

            // If cart is empty, re-render the cart drawer to show empty state
            if (parsedState.item_count === 0) {
              cartDrawerWrapper.renderContents(parsedState);
            }
          }

          // Only update sections that exist and have content
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                ?.querySelector(section.selector) ||
              document.getElementById(section.id);

            if (
              elementToReplace &&
              parsedState.sections &&
              parsedState.sections[section.section]
            ) {
              try {
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              } catch (error) {
                console.warn(`Failed to update section ${section.id}:`, error);
              }
            } else {
            }
          });

          const cartSpan = document.querySelector(".cart-span-counter");
          const globalCartCounter = document.querySelector(
            "#cart-icon-bubble .cart-count-bubble"
          ).innerHTML;

          if (cartSpan) {
            cartSpan.innerHTML = globalCartCounter;
          }

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(
                  cartDrawerWrapper,
                  lineItem.querySelector(`[name="${name}"]`)
                )
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper.querySelector(".drawer__inner-empty"),
              cartDrawerWrapper.querySelector("a")
            );
          } else if (
            document.querySelector(".cart-item") &&
            cartDrawerWrapper
          ) {
            trapFocus(
              cartDrawerWrapper,
              document.querySelector(".cart-item__name")
            );
          }
          this.disableLoading();
        } catch (error) {
          console.error("Cart update error:", error);

          // Use the actual error message from the response
          const errorMessage = error.message;

          // Revert the quantity input to the actual cart quantity
          const quantityInput = document.querySelector(
            `[data-index="${line}"]`
          );
          if (quantityInput) {
            // Fetch the current cart state to get the actual quantity
            fetch("/cart.js")
              .then((response) => response.json())
              .then((cart) => {
                // Try to find the cart item by line number (0-based index)
                const cartItem = cart.items[line];
                if (cartItem) {
                  quantityInput.value = cartItem.quantity;

                  // Prevent the change event from triggering another cart update
                  quantityInput.setAttribute("data-reverting", "true");

                  // Trigger change event to update any dependent UI
                  quantityInput.dispatchEvent(
                    new Event("change", { bubbles: true })
                  );

                  // Remove the flag after a short delay
                  setTimeout(() => {
                    quantityInput.removeAttribute("data-reverting");
                  }, 100);
                } else {
                  console.log("No cart item found for line:", line);
                  console.log("Available cart items:", cart.items);
                }
              })
              .catch((fetchError) => {
                console.error(
                  "Error fetching cart state for quantity revert:",
                  fetchError
                );
              });
          } else {
            console.log("No quantity input found for line:", line);
          }

          this.querySelectorAll(".loading-overlay").forEach((overlay) =>
            overlay.classList.add("hidden")
          );
          const errors =
            document.getElementById("cart-errors") ||
            document.getElementById("CartDrawer-CartErrors");
          console.log("Error element found:", errors);
          if (errors) {
            // Check if it's an inventory error
            if (
              errorMessage.includes("availability") ||
              errorMessage.includes("Only")
            ) {
              errors.textContent = errorMessage;
              console.log("Showing inventory error:", errorMessage);
            } else {
              errors.textContent = `Error updating cart: ${errorMessage}`;
              console.log("Showing generic error:", errorMessage);
            }
            errors.style.display = "block";
            console.log("Error element display set to block");

            // Hide the error after 30 seconds
            setTimeout(() => {
              errors.style.display = "none";
            }, 30000);
          } else {
            console.log("No error element found");
          }
          this.disableLoading();
        }
      })
      .catch((error) => {
        console.error("Cart update error:", error);

        // Use the actual error message from the response
        const errorMessage = error.message;

        // Revert the quantity input to the actual cart quantity
        const quantityInput = document.querySelector(`[data-index="${line}"]`);
        if (quantityInput) {
          // Fetch the current cart state to get the actual quantity
          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              // Try to find the cart item by line number (0-based index)
              const cartItem = cart.items[line];
              if (cartItem) {
                quantityInput.value = cartItem.quantity;

                // Prevent the change event from triggering another cart update
                quantityInput.setAttribute("data-reverting", "true");

                // Trigger change event to update any dependent UI
                quantityInput.dispatchEvent(
                  new Event("change", { bubbles: true })
                );

                // Remove the flag after a short delay
                setTimeout(() => {
                  quantityInput.removeAttribute("data-reverting");
                }, 100);
              } else {
              }
            })
            .catch((fetchError) => {
              console.error(
                "Error fetching cart state for quantity revert:",
                fetchError
              );
            });
        } else {
        }

        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        if (errors) {
          // Check if it's an inventory error
          if (
            errorMessage.includes("availability") ||
            errorMessage.includes("Only")
          ) {
            errors.textContent = errorMessage;
          } else {
            errors.textContent = `Error updating cart: ${errorMessage}`;
          }
          errors.style.display = "block";

          // Hide the error after 30 seconds
          setTimeout(() => {
            errors.style.display = "none";
          }, 30000);
        } else {
          console.log("No error element found");
        }
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      if (lineItemError && quantityElement) {
        const errorTextElement = lineItemError.querySelector(
          ".cart-item__error-text"
        );
        if (errorTextElement) {
          errorTextElement.innerHTML = window.cartStrings.quantityError.replace(
            "[quantity]",
            quantityElement.value
          );
        }
      }
    }

    this.currentItemCount = itemCount;
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", true);
    }

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}

class WrappedGiftBoxHandler {
  constructor() {
    this.giftWrapProductId = "7759621849321";
    this.giftWrapVariantId = "43258393526505";
    this.giftWrapCheckboxes = null;
    this.isWrappedAppAvailable = false;
    this.init();
  }

  init() {
    this.waitForWrappedElements();
  }

  waitForWrappedElements() {
    const checkInterval = setInterval(() => {
      const checkboxes = document.querySelectorAll(
        'wrapped-feature-checkbox-simple input[type="checkbox"]'
      );

      if (checkboxes.length > 0) {
        clearInterval(checkInterval);
        this.giftWrapCheckboxes = checkboxes;
        this.isWrappedAppAvailable = true;
        this.setupEventListeners();
        this.monitorCartChanges();
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
      if (!this.isWrappedAppAvailable) {
        // Don't throw an error, just log that the app isn't available
      }
    }, 10000);
  }

  setupEventListeners() {
    document.addEventListener("change", (event) => {
      if (event.target.classList.contains("quantity__input")) {
        setTimeout(() => this.checkCartState(), 500);
      }
    });

    document.addEventListener("click", (event) => {
      const removeButton =
        event.target.closest(".button--tertiary") ||
        event.target.closest("cart-remove-button");
      if (removeButton) {
        setTimeout(() => this.checkCartState(), 500);
      }
    });

    if (this.giftWrapCheckboxes) {
      this.giftWrapCheckboxes.forEach((checkbox, index) => {
        checkbox.addEventListener("change", (event) => {
          setTimeout(() => this.checkCartState(), 500);
        });
      });
    }
  }

  monitorCartChanges() {
    // This method monitors for cart changes and can be extended as needed
  }

  async checkCartState() {
    // Only proceed if Wrapped app is available
    if (!this.isWrappedAppAvailable) {
      return;
    }

    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      const regularItems = cart.items.filter(
        (item) =>
          item.product_id.toString() !== this.giftWrapProductId &&
          item.variant_id.toString() !== this.giftWrapVariantId
      );

      if (regularItems.length === 0) {
        const giftItem = cart.items.find(
          (item) => item.variant_id.toString() === this.giftWrapVariantId
        );

        if (giftItem) {
          await this.removeGiftWrap(giftItem.key);
          this.uncheckAllGiftWrapCheckboxes();
        }
      }
    } catch (error) {
      console.error("Error in checkCartState:", error);
    }
  }

  async removeGiftWrap(itemKey) {
    try {
      const removeResponse = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      });

      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            "Gift Wrap": "",
            "Gift Option": "",
            "_Gift Option ID": "",
          },
        }),
      });

      window.location.reload();
    } catch (error) {
      console.error("Error in removeGiftWrap:", error);
    }
  }

  uncheckAllGiftWrapCheckboxes() {
    if (this.giftWrapCheckboxes) {
      this.giftWrapCheckboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
  }
}

// Initialize with delay and additional logging
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    new WrappedGiftBoxHandler();
  }, 1000);
});
